import gql from 'graphql-tag'

export default gql`
  query getPitch($id: String!) {
    getExpert(id: $id) {
      id
      industryTags
      financialTags
      softwareTags
      workExperiences {
        industryTags
        financialTags
        softwareTags
      }
      externalProjects {
        industryTags
        financialTags
        softwareTags
      }
      personalSummary {
        id
        aboutYourself
        topIndustries
        topFinancialSkills
        topSoftwareSkills
        whyFreelanceWork
      }
      onboardingStep
    }
  }
`
